import React, { useEffect, useRef, useState } from "react";
import TablaSuspensiones from "./TablaSuspensiones";
import TablaHorasTrabajadas from "./TablaHorasTrabajadas";
import TablaGenerica from "./TablaGenerica";

const PanelDetalle = ({ tipo, data, onClose }) => {
    const panelRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    const tituloCapitalizado = tipo ? tipo.charAt(0).toUpperCase() + tipo.slice(1) : "Sin tipo";

    if (!Array.isArray(data)) return null;

    return (
        <div
            className={`side-panel ${tipo === "suspensiones" ? "con-acciones" : ""} ${tipo === "horasTrabajadas" ? "panel-horas" : ""}`}
            ref={panelRef}
        >
            <div className="side-panel-header">
                <h2 className="titulo-asistencia-empleado">Detalle de {tituloCapitalizado}</h2>
                <button onClick={onClose} className="close-button">X</button>
            </div>

            {tipo === "suspensiones" && <TablaSuspensiones data={data} />}
            {tipo === "horasTrabajadas" && <TablaHorasTrabajadas data={data} />}
            {tipo !== "suspensiones" && tipo !== "horasTrabajadas" && <TablaGenerica data={data} />}
        </div>
    );
};

export default PanelDetalle;
